var exports = {};
const union = (t, e) => {
    let n = new Set(t);
    for (let t of e) n.add(t);
    return n;
  },
  subtract = (t, e) => {
    let n = new Set(t);
    for (let t of e) n.delete(t);
    return n;
  };
exports = {
  union,
  subtract
};
export default exports;